import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { renderInfoForType } from '../../../../../utils/helpers';
import Map from '../../../../../components/customFields/MapLocationDetail';
import AttachmentDetail from '../../../../../components/customFields/AttachmentDetail';
import styles from './defaultPrint.module.scss';
import ChecklistPrintDisplay from './ChecklistPrintDisplay';
import RiskStatus from './statusColor';
import MultiLocation from '../../../../../pulpo_visualizer/fields/multi_location/multiLocation';
import SharedCustomFieldDetail from '../../../../../components/customFields/CustomFieldDetail';

const CustomFieldDetail = ({ data, fields, version, user, selectedLang, formImage, isPrintWithoutData,
  attachmentRelatedField, attachmentEndOfthePage, mcgHeader
 }) => {
  const [ssiPermission, setSsiPermission] = useState(false);
  const selected_users = useSelector(userdata => userdata?.form?.selected_users);
  const selectedUserNames = selected_users?.dropdown_users?.map(item => ({ key: item.id, value: item.fullname })) || [];
  useEffect(() => {
    if (user.id) {
    const havingRole = user?.roles?.filter(
      e => e?.meta_data?.ssi_data === true || e.name === 'System Admin'
    );
    if (havingRole?.length > 0) setSsiPermission(true);
    }
  }, [user, ssiPermission]);

  const checkConditionalValue = (field) => {
    let isValue = false;
    if (typeof data[field?.conditional_field?.key] === 'string') {
      isValue = field?.conditional_values.filter(
        value => data[field?.conditional_field?.key] === value.value
      ).length > 0;
    }
    if (typeof data[field?.conditional_field?.key] === 'object') {
      if (Array.isArray(data[field?.conditional_field?.key])) {
        isValue = field?.conditional_values.some(
            value => data[field?.conditional_field?.key].indexOf(value.value) !== -1
        );
    } else if (data[field?.conditional_field?.key]?.level_0) {
        isValue = Object.values(data[field?.conditional_field?.key])
        ?.filter(value => value !== '')
        ?.join()
        === Object.values(field.conditional_values[0])
        ?.filter(value => value !== '')
        ?.join();
    }
    } else if (typeof data[field?.conditional_field?.key] === 'boolean') {
      isValue = field?.conditional_values.filter(
        value => (
          data[field?.conditional_field?.key].toString() === value?.value
        )
      ).length > 0;
    }

    return isValue;
  };

  const getAddress = (value) => {
    let addressInfo = [value?.street, value?.fulladdress, value?.zip, value?.country?.value];
    let updatedAddress = [];
    if (addressInfo) {
      addressInfo.map((item) => {
        if (item !== '' && item !== null && item !== undefined) {
          updatedAddress = [
            ...updatedAddress,
            item
          ];
        }
        return null;
      });
    }
    return updatedAddress.join(', ');
  };

  const handleGetPrintField = (val) => {
    if (val.internal && val.field_for_print_pdf) {
      return true;
    } if (val.internal && !val.field_for_print_pdf) {
      return false;
    }
      return true;
  };

  const printSty = {
    fontSize: '1.8rem',
    fontFamily: 'Lato',
    fontWeight: 'normal'
  };

let className;
let fullClassName;

if (isPrintWithoutData) {
  className = `${styles.infoHalf1} ${styles.halfWidth}`;
  fullClassName = `${styles.infoFull1} ${styles.halfWidth}`;
} else {
  className = `${styles.infoHalf} ${styles.halfWidth}`;
  fullClassName = `${styles.infoFull} ${styles.halfWidth}`;
}
const getToggleText = (f, toggleData) => {
  if (toggleData[f.id] === true) {
    return f.settings.enableToggleText.length > 0
      ? f.settings.enableToggleText
      : 'yes';
  }
    return f.settings.disableToggleText.length > 0
      ? f.settings.disableToggleText
      : 'no';
};
const airportCoordinates = user?.airport?.location?.coordinates || user?.portal_airport?.location?.coordinates;
  return (
    <div className={`${styles.stepInfo} ${styles.noMarginTop}`}>
      {fields.map(f => (
      <>
               {f.type === 'toggle' && (
               <div key={f.id} className={`${styles.infoHalf} ${styles.halfWidth}`}>
                 <span>{f.title}</span>
                 <p> {getToggleText(f, data)}</p>
               </div>
             )}
      {f.type === 'page_break' && <div style={{ pageBreakAfter: 'always', flex: 'none' }} />}
        {!f.conditional && handleGetPrintField(f) && (
          <>
            {f.type === 'header' && f.type !== 'map_location' && (
              <div key={f.id} className={styles.infoFull} style={{ backgroundColor: '#c5c5c5' }}>
                <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
              </div>
            )}
            {f?.type === 'dataSource' && (
              <>
                {typeof data[f.id] === 'object'
                && f?.dataSourceID === 'ds6'
                && data[f.id]?.detailId && (
                  <>
                    <div
                      key={f.id}
                      className={f.full_width ? styles.infoFull : className}
                    >
                      <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                      { !isPrintWithoutData
                      && <p style={printSty}>
                        {data[f.id] && (
                          renderInfoForType(f, data[f.id]?.value, version, version?.schema, false, user)
                        )}
                         </p>
                      }
                    </div>
                  </>
                )}
                {typeof data[f.id] === 'string' && (
                  <div
                    key={f.id}
                    className={f.full_width ? styles.infoFull : className}
                  >
                    <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                    { !isPrintWithoutData
                    && <p style={printSty}>
                      {data[f.id] && (
                        renderInfoForType(f, data[f.id], version, version?.schema, false, user)
                      )}
                       </p>
                    }
                  </div>
                )}
              </>
            )}
            { !isPrintWithoutData
            && f.type === 'map_location' && f?.shape !== 'All'
              && !f?.settings?.allow_multiple_location
              && user
              && user.portal_airport
              && Object.keys(user.portal_airport.location).length > 0 && (
                <>
                  {f.address_location && (
                    <div key={f.id} className={styles.infoFull}>
                      <span>
                        <FormattedMessage
                          id="customfield.address"
                          defaultMessage="Address"
                        />
                      </span>
                      <p style={printSty}>{data[f.id]?.address}</p>
                    </div>
                  )}
                  {data[f.id] && (
                    <div key={f.id} className={`${styles.infoMap} ${styles.printMapBlock}`}>
                      <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                      <div className={`${styles.map} ${styles.printMapCanvas}`}>
                        <Map shape={f.shape} location={data[f.id]} printMap />
                      </div>
                    </div>
                  )}
                </>
            )}
            {!isPrintWithoutData && f.type === 'map_location'
              && (f?.shape === 'All' || f?.settings?.allow_multiple_location)
              && user
              && user.portal_airport
              && Object.keys(user.portal_airport.location).length > 0 && (
                <>
                  {data[f.id] && (
                    <div key={f.id} className={`${styles.infoMap} ${styles.printMapBlock}`}>
                      <span>{(selectedLang !== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                      <div className={`${styles.map} ${styles.printMapCanvas}`}>
                        <MultiLocation
                          answer={data[f.id]}
                          handleFieldErrorChanged={() => { }}
                          handleValueChange={() => { }}
                          fromForms
                          onlyLocationView
                          disabled
                          allowMultiple={f?.settings?.allow_multiple_location}
                          airportInfo={{
                            location: user?.portal_airport?.location?.coordinates,
                            map_style: user?.portal_airport?.airport_settings?.map_style,
                            mapbox_style: user?.portal_airport?.airport_settings?.mapbox_style,
                            custom_map_url: user?.portal_airport?.airport_settings?.custom_map_url
                          }}
                          printMap
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            {f.type === 'inspection_checklist' && (
              <>
              <div
              key={f.id}
              className={styles.infoFull}
            >
              <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name :f.title}</span>
              </div>
              <ChecklistPrintDisplay
                useFieldData={f}
                handleItemStatusChange={() => ({})}
                pass={undefined}
                check_list_answers={data?.[f?.id]}
                displayChecklist
                isPrintWithoutData={isPrintWithoutData}
              />
              </>
            )}
            {f.type?.includes('MultiLevel') && (
              <>
                {!isPrintWithoutData
                  && f?.dataSourceID === 'ds2'
                  && (data[f.id]?.map_location?.length > 0)
                  && airportCoordinates && (
                    <div className={`${styles.infoMap} ${styles.printMapBlock}`}>
                      <div className={`${styles.map} ${styles.printMapCanvas}`}>
                        <Map
                          shape="Point"
                          location={{ coordinates: [...data[f.id]?.map_location].reverse(), type: 'Point' }}
                          printMap
                        />
                      </div>
                    </div>
                  )}
                <div className={styles.multiLevelWrapper}>
                  {f?.levels && Object.keys(f.levels).map(level => (
                    <div key={`${f.id}_${level}`} className={isPrintWithoutData ? styles.infoHalf1 : styles.infoHalf}>
                      <span>{f.levels[level]?.title || level?.replace('_', ' ')}</span>
                      { !isPrintWithoutData
                      && <p>{data[f.id]?.[level]}</p>
                      }
                    </div>
                  ))}
                </div>
              </>
            )}
            {f.type === 'risk_assess' && data[f.id] && (
              <div
                key={f.id}
                className={styles.infoFull}
                >
                <span>{f.title}</span>
                {data[f.id]?.value && (
                  <div style={{ width: '100px' }}>
                    <RiskStatus
                      status={data[f.id]?.risk_levels?.map(level => (
                        { name: data[f.id]?.value, description: level.description, color: level.color }
                      ))}
                    />
                  </div>
                )}
              </div>
            )}
            {(f.type === 'wildlife_species' || f.type === 'dataSource' && f.dataSourceID === 'ds10') && data[f.id] && (
              <>
                <div
                  key={f.id}
                  className={styles.infoFull}
                  style={{ padding: '0' }}
                >
                  <span style={{ padding: '10px 16px', margin: '0' }}>{f.title}</span>
                  <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #E6EAEE' }}>
                    <div className={`${styles.wildLifeFieldsCells} ${styles.borderRight}`}>
                      <FormattedMessage
                        id="wildlife.form.type"
                        defaultMessage="Wildlife Type"
                      />
                      <p>{data[f.id]?.type || ''}</p>
                    </div>
                    <div className={styles.wildLifeFieldsCells}>
                      <FormattedMessage
                        id="wildlife.form.species"
                        defaultMessage="Wildlife Species"
                      />
                      <p>{data[f.id]?.species || ''}</p>
                    </div>
                  </div>
                </div>
              </>)}
            {f.type === 'multi_level'
                  && data?.[f?.id] && Object.values(data?.[f.id]).filter(val => val).map((category, index) => (
                    <div key={category} className={isPrintWithoutData ? styles.infoHalf1 : styles.infoHalf}>
                      <span>{index === 0 ? `${(selectedLang && selectedLang !=='' ? (f?.meta_data?.[selectedLang]?.multiLevelTitles?.level_1
                              || `${f?.title}`): ((f?.meta_data?.[user?.language]?.multiLevelTitles?.level_1) || `${f?.title}`))}`
                              : `${(selectedLang && selectedLang !==''? (f?.meta_data?.[selectedLang]?.multiLevelTitles?.[`level_${index+1}`]
                              || `${f?.title} ${index}`)
                              : ((f?.meta_data?.[user?.language]?.multiLevelTitles?.[`level_${index+1}`]) || `${f?.title} ${index}`))}`}
                      </span>
                          { !isPrintWithoutData
                          && <p>{category}</p>
                          }
                    </div>
                ))}
              {f.type === 'multi_field'
              && f?.multiple_fields
              && Object.keys(f?.multiple_fields).map((multi_field) => {
                if (f?.multiple_fields?.[multi_field]?.codeValues) {
                  const selectedKey = data[f.id]?.[0]?.[multi_field];
                  const codedValue = f?.multiple_fields?.[multi_field]?.values?.find(
                    item => item.key === selectedKey
                  )?.coded_value;
                  return (
                    <div
                      key={`${f.id}_${multi_field}`}
                      className={
                        f.full_width ? styles.infoFull : `${styles.infoHalf} ${styles.halfWidth}`
                      }
                    >
                      <span>{f?.multiple_fields?.[multi_field]?.textForCodedValues}</span>
                      <p>{codedValue}</p>
                    </div>
                  );
                }
                return null;
              })}
            {!f.type?.includes('MultiLevel') && f.type !== 'multi_field'
              && f.type !== 'header' && f.type !== 'ssi_field'
              && f.type !== 'dataSource' && f.type !== 'risk_assess' && f.type !== 'wildlife_species'
              && f.type !== 'map_location' && f.type !== 'attachments'
              && f.type !== 'page_break' && f.type !== 'signature' && f.type !== 'address' && f.type !== 'multi_level'
              && f.type !== 'inspection_checklist' && f.type !== 'duration' && f.type !== 'toggle' && (
                <>
                <div
                  key={f.id}
                  className={
                    (f.widget && f.widget.type === 'textfield') || f.type === 'header' || f.full_width
                      ? styles.infoFull
                      : className
                  }
                >
                  <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                  { !isPrintWithoutData
                  && <p style={f.type === 'string' && f?.widget?.type === 'textfield' ? printSty : {}}>
                    {data[f.id]
                      && renderInfoForType(f, data[f.id], version, version?.schema, true, user, selectedLang, selectedUserNames)}
                     </p>
                  }
                </div>
                {f.type === 'select' && f.settings?.codeValues && (
                  <div key={f.id} className={f.full_width ? styles.infoFull : `${styles.infoHalf} ${styles.halfWidth}`}>
                    <span>{f?.settings?.textForCodedValues}</span>
                      <p>
                          {f.values[data[f.id]].coded_value}
                      </p>
                  </div>)}
                </>
            )}
            {f?.type === 'duration' && (
              <div
                key={f.id}
                className={f.full_width
                  ? styles.infoFull
                  : className}
              >
                <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                { !isPrintWithoutData && (
                  <p>
                    {data[f.id]}
                  </p>
                )}
              </div>
            )}
            {f.type === 'signature' && !isPrintWithoutData && (
              <AttachmentDetail attachments={data[f.id]}
              title={(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title} defaultPrint />
            )}
            {f.type === 'signature' && isPrintWithoutData && (
              <div className={styles.infoFull1}><span>{f?.meta_data?.[selectedLang]?.name || f.title}</span></div>
            )}
             {mcgHeader && data?.[f?.id] && f?.type === 'multi_field' && (
                  <div key={f?.id} className={styles.infoFull}><span>{f?.title}</span></div>
                )}
            {data?.[f?.id] && f?.type === 'multi_field' && (
              <div style={{ width: '100%', padding: mcgHeader ? '10px' : '0px' }}>
                <SharedCustomFieldDetail
                  data={data}
                  fields={[f]}
                  version="isPrint"
                  user={user}
                  selectedLang={selectedLang}
                  mcgHeader={mcgHeader}
                />
              </div>
            )}
            {f?.type === 'address' && data?.[f?.id] && typeof data?.[f?.id] === 'object'
            ? (
              <div
                key={f?.id}
                className={f.full_width ? styles.infoFull : fullClassName}
              >
                <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                { !isPrintWithoutData
                && <p>{getAddress(data?.[f?.id])}</p>
                }
              </div>
            )
            : f?.type === 'address' && (
              <div
                key={f?.id}
                className={f.full_width ? styles.infoFull : fullClassName}
              >
                <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                { !isPrintWithoutData
                && <p>{data[f?.id]}</p>
                }
              </div>
            )}
            {f.type === 'attachments' && data[f.id] && !isPrintWithoutData && attachmentRelatedField && handleGetPrintField(f) && (
              <>
                {data?.[f?.id] && f?.type === 'multi_field' && data?.[f?.id]?.map((multi_data, index) => (
                  <div style={{ pageBreakInside: 'avoid', borderBottom: '1px solid #E6EAEE' }}>
                    {f?.multiple_fields && Object.keys(f?.multiple_fields)?.map(multi_field => (
                      <>
                      { !isPrintWithoutData
                        && f?.multiple_fields?.[multi_field]?.type?.key === 'attachments' && (
                          <AttachmentDetail
                            attachments={multi_data?.[multi_field]}
                            title={`${f?.multiple_fields?.[multi_field]?.title} - ${index + 1}`}
                            field={f}
                            displayLink
                            defaultPrint
                            attachmentEndOfthePage={attachmentEndOfthePage}
                            attachmentRelatedField={attachmentRelatedField}
                          />
                        )}
                      </>
                    ))}
                  </div>
                ))}
                <div className={styles.fullWidth}>
                  <AttachmentDetail attachments={data[f.id]} formImage={formImage}
                    title={(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title} defaultPrint
                    fieldData={f}
                    attachmentEndOfthePage={attachmentEndOfthePage}
                    attachmentRelatedField={attachmentRelatedField}
                  />
                </div>
              </>
            )}
          </>
        )}
        {f.conditional && handleGetPrintField(f)
          && data[f?.conditional_field?.key]
          && checkConditionalValue(f) && (
            <>
              {f.type === 'header' && f.type !== 'map_location' && (
                <div key={f.id} className={styles.infoFull}>
                  <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                </div>
              )}
              {f.type === 'map_location' && f?.shape !== 'All'
                && !f?.settings?.allow_multiple_location
                && user
                && user.portal_airport
                && Object.keys(user.portal_airport.location).length > 0 && (
                  <>
                    {f.address_location && (
                      <div key={f.id} className={styles.infoFull}>
                        <span>
                          <FormattedMessage
                            id="customfield.address"
                            defaultMessage="Address"
                          />
                        </span>
                        <p>{data[f.id]?.address}</p>
                      </div>
                    )}
                    {data[f.id] && (
                      <div key={f.id} className={`${styles.infoMap} ${styles.printMapBlock}`}>
                        <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                        <div className={`${styles.map} ${styles.printMapCanvas}`}>
                          <Map shape={f.shape} location={data[f.id]} printMap />
                        </div>
                      </div>
                    )}
                  </>
              )}
              {f.type === 'map_location' && (f?.shape === 'All'
              || f?.settings?.allow_multiple_location)
                && user
                && user.portal_airport
                && Object.keys(user.portal_airport.location).length > 0 && (
                  <>
                    {data[f.id] && (
                      <div key={f.id} className={`${styles.infoMap} ${styles.printMapBlock}`}>
                        <span>{(selectedLang !== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                        <div className={`${styles.map} ${styles.printMapCanvas}`}>
                          <MultiLocation
                            answer={data[f.id]}
                            handleFieldErrorChanged={() => { }}
                            handleValueChange={() => { }}
                            fromForms
                            onlyLocationView
                            disabled
                            allowMultiple={f?.settings?.allow_multiple_location}
                            airportInfo={{
                              location: user?.portal_airport?.location?.coordinates,
                              map_style: user?.portal_airport?.airport_settings?.map_style,
                              mapbox_style: user?.portal_airport?.airport_settings?.mapbox_style,
                              custom_map_url: user?.portal_airport?.airport_settings?.custom_map_url
                            }}
                            printMap
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              { !isPrintWithoutData
              && f.type === 'attachments' && data[f.id] && (
                <AttachmentDetail attachments={data[f.id]}
                title={(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title} defaultPrint
                attachmentEndOfthePage={attachmentEndOfthePage}
                attachmentRelatedField={attachmentRelatedField}
              />
              )}
              {f.type?.includes('MultiLevel') && (
              <>
                {!isPrintWithoutData
                  && f?.dataSourceID === 'ds2'
                  && (data[f.id]?.map_location?.length > 0)
                  && airportCoordinates && (
                    <div className={`${styles.infoMap} ${styles.printMapBlock}`}>
                      <div className={`${styles.map} ${styles.printMapCanvas}`}>
                        <Map
                          shape="Point"
                          location={{ coordinates: [...data[f.id]?.map_location].reverse(), type: 'Point' }}
                          printMap
                        />
                      </div>
                    </div>
                  )}
                <div className={styles.multiLevelWrapper}>
                  {f?.levels && Object.keys(f?.levels).map(level => (
                    <div key={`${f.id}_${level}`} className={styles.infoHalf}>
                      <span>{f?.levels[level]?.title}</span>
                      { !isPrintWithoutData
                      && <p>{data[f.id]?.[level]}</p>
                      }
                    </div>
                  ))}
                </div>
              </>
              )}
              {f?.type === 'dataSource' && (
                <>
                  {typeof data[f.id] === 'object'
                  && f?.dataSourceID === 'ds6'
                  && data[f.id]?.detailId && (
                    <>
                      <div
                        key={f.id}
                        className={f.full_width ? styles.infoFull : `${styles.infoHalf} ${styles.halfWidth}`}
                      >
                        <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                        { !isPrintWithoutData
                        && <p style={printSty}>
                          {data[f.id] && (
                            renderInfoForType(f, data[f.id]?.value, version, version?.schema, false, user)
                          )}
                           </p>
                        }
                      </div>
                    </>
                  )}
                  {typeof data[f.id] === 'string' && (
                    <div
                      key={f.id}
                      className={f.full_width ? styles.infoFull : `${styles.infoHalf} ${styles.halfWidth}`}
                    >
                      <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                      { !isPrintWithoutData
                      && <p style={printSty}>
                        {data[f.id] && (
                          renderInfoForType(f, data[f.id], version, version?.schema, false, user)
                        )}
                         </p>
                      }
                    </div>
                  )}
                </>
              )}
              {f.type === 'multi_level'
                && data?.[f?.id] && Object.values(data?.[f.id]).filter(val => val).map((category, index) => (
                  <div key={category} className={styles.infoHalf}>
                        <span>{index === 0 ? `${f?.title}` : `${f?.title} ${index}`}</span>
                        { !isPrintWithoutData
                        && <p style={printSty}>{category}</p>
                        }
                  </div>
              ))}
              {f.type === 'risk_assess' && data[f.id] && (
                <div
                  key={f.id}
                  className={styles.infoFull}
                  >
                  <span>{f.title}</span>
                  {data[f.id]?.value && (
                    <div style={{ width: '100px' }}>
                      <RiskStatus
                        status={data[f.id]?.risk_levels?.map(level => (
                          { name: data[f.id]?.value, description: level.description, color: level.color }
                        ))}
                      />
                    </div>
                  )}
                </div>
              )}
              {f.type === 'wildlife_species' && data[f.id] && (
              <>
                <div
                  key={f.id}
                  className={styles.infoFull}
                  style={{ padding: '0' }}
                >
                  <span style={{ padding: '10px 16px', margin: '0' }}>{f.title}</span>
                  <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #E6EAEE' }}>
                    <div className={`${styles.wildLifeFieldsCells} ${styles.borderRight}`}>
                      <FormattedMessage
                        id="wildlife.form.type"
                        defaultMessage="Wildlife Type"
                      />
                      <p style={printSty}>{data[f.id]?.type || ''}</p>
                    </div>
                    <div className={styles.wildLifeFieldsCells}>
                      <FormattedMessage
                        id="wildlife.form.species"
                        defaultMessage="Wildlife Species"
                      />
                      <p style={printSty}>{data[f.id]?.species || ''}</p>
                    </div>
                  </div>
                </div>
              </>)}
              {data?.[f?.id] && f?.type === 'multi_field' && (
                <div style={{ width: '100%', padding: '0px' }}>
                  <SharedCustomFieldDetail
                    data={data}
                    fields={[f]}
                    version="isPrint"
                    user={user}
                    selectedLang={selectedLang}
                  />
                </div>
              )}
            {f.type === 'multi_field'
              && f?.multiple_fields
              && Object.keys(f?.multiple_fields).map((multi_field) => {
                if (f?.multiple_fields?.[multi_field]?.codeValues) {
                  const selectedKey = data[f.id]?.[0]?.[multi_field];
                  const codedValue = f?.multiple_fields?.[multi_field]?.values?.find(
                    item => item.key === selectedKey
                  )?.coded_value;
                  return (
                    <div
                      key={`${f.id}_${multi_field}`}
                      className={
                        f.full_width ? styles.infoFull : `${styles.infoHalf} ${styles.halfWidth}`
                      }
                    >
                      <span>{f?.multiple_fields?.[multi_field]?.textForCodedValues}</span>
                      <p>{codedValue}</p>
                    </div>
                  );
                }
                return null;
              })}
              {!f.type?.includes('MultiLevel') && f.type !== 'header' && f.type !== 'ssi_field'
                && f.type !== 'map_location' && f.type !== 'attachments'
                && f.type !== 'signature' && f.type !== 'dataSource'
                && f.type !== 'multi_field' && f.type !== 'multi_level'
                && f.type !== 'risk_assess' && f.type !== 'wildlife_species' && f.type !== 'toggle' && (
                  <>
                  <div
                    key={f.id}
                    className={
                      (f.widget && f.widget.type === 'textfield') || f.type === 'header' || f.full_width
                        ? styles.infoFull
                        : `${styles.infoHalf} ${styles.halfWidth}`
                    }
                  >
                    <span>{(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title}</span>
                    { !isPrintWithoutData
                    && <p style={f.type === 'string' && f?.widget?.type === 'textfield' ? printSty : {}}>
                      {data[f.id]
                        && renderInfoForType(f, data[f.id], version, version?.schema, true, false, selectedLang)}
                       </p>
                    }
                  </div>
                  {f.type === 'select' && f.settings?.codeValues && (
                  <div key={f.id} className={f.full_width ? styles.infoFull : `${styles.infoHalf} ${styles.halfWidth}`}>
                    <span>{f?.settings?.textForCodedValues}</span>
                      <p>
                          {f.values[data[f.id]].coded_value}
                      </p>
                  </div>)}
                  </>
              )}
              {f.type === 'signature' && (
                <AttachmentDetail attachments={data[f.id]}
                title={(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title} defaultPrint />
              )}
            </>
        )}
      </>
      ))}
      {attachmentEndOfthePage && (
        <>
        {fields.map(f => (
          <>
            {!f.conditional && handleGetPrintField(f) && (
              <>
                {data?.[f?.id] && f?.type === 'multi_field' && data?.[f?.id]?.map((multi_data, index) => (
                  <div style={{ pageBreakInside: 'avoid', borderBottom: '1px solid #E6EAEE' }}>
                    {f?.multiple_fields && Object.keys(f?.multiple_fields)?.map(multi_field => (
                      <>
                      { !isPrintWithoutData
                        && f?.multiple_fields?.[multi_field]?.type?.key === 'attachments' && (
                          <AttachmentDetail
                            attachments={multi_data?.[multi_field]}
                            title={`${f?.multiple_fields?.[multi_field]?.title} - ${index + 1}`}
                            field={f}
                            displayLink
                            defaultPrint
                            attachmentEndOfthePage={attachmentEndOfthePage}
                            attachmentRelatedField={attachmentRelatedField}
                          />
                        )}
                      </>
                    ))}
                  </div>
                ))}
                <div className={styles.fullWidth}>
                { !isPrintWithoutData
                && f.type === 'attachments' && data[f.id] && (
                <AttachmentDetail attachments={data[f.id]} formImage={formImage}
                title={(selectedLang!== '' && f?.meta_data?.[selectedLang]?.name) ? f?.meta_data?.[selectedLang]?.name : f.title} defaultPrint
                fieldData={f}
                attachmentEndOfthePage={attachmentEndOfthePage}
                attachmentRelatedField={attachmentRelatedField}
                />
              )}
                </div>
              </>
            )}
          </>
        ))}
        </>
      )}
    </div>
  );
};

CustomFieldDetail.propTypes = {
  data: PropTypes.shape({}),
  fields: PropTypes.shape([]),
  mcgHeader: PropTypes.bool
};

CustomFieldDetail.defaultProps = {
  data: {},
  fields: [],
  mcgHeader: false
};

const mapStateToProps = state => ({
  user: state.auth.profile
});

export default connect(mapStateToProps, {})(CustomFieldDetail);
